import {ITraveller} from "@/model/Traveller"

export interface IHasTravellersIncluded {
    getTravellersIncluded(): ITraveller[]
    getTravellersIncludedMap(): Map<string, ITraveller>
    addTravellerIncluded(traveller: ITraveller): void
    removeTravellerIncluded(traveller: ITraveller): void
}

function hasTravellersIncluded<TBase extends Constructor>(Base: TBase) {
    
    class Bob extends Base implements IHasTravellersIncluded {
        private travellersIncluded: ITraveller[] = []
        private travellersIncludedMap: Map<string, ITraveller> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }
        
        public getTravellersIncluded(): ITraveller[] {
            return this.travellersIncluded
        }
        public getTravellersIncludedMap(): Map<string, ITraveller> {
            return this.travellersIncludedMap
        }
        public addTravellerIncluded(traveller: ITraveller): void {
            if (this.travellersIncludedMap.has(traveller.getId())) return
            this.travellersIncluded.push(traveller)
            this.travellersIncludedMap.set(traveller.getId(), traveller)
        }
        public removeTravellerIncluded(traveller: ITraveller): void {
            if (!this.travellersIncludedMap.has(traveller.getId())) return
            this.travellersIncluded = this.travellersIncluded.filter((_=>_.getId() !== traveller.getId()))
            this.travellersIncludedMap.delete(traveller.getId())
        }
    }
    return Bob
}

export default hasTravellersIncluded